module.exports = __webpack_public_path__ + "static/media/video-guide-two.6bdbbbb3.mp4";